import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import withWidth from 'material-ui/utils/withWidth';
import compose from 'recompose/compose';
import {translate} from 'admin-on-rest';

const styles = {
    floating: {
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 60,
        left: 'auto',
        position: 'fixed',
    },
    flat: {
        overflow: 'inherit',
        backgroundColor: '#57B8CF',
        color: "#FFF",
        margin: 10,
        borderRadius: 0,
        boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px"
    },
};

const CreateButton = ({
    basePath = '',
    translate,
    label = 'resources.giftCards.create'
}) => (
    <FlatButton
        primary
        label={label && translate(label)}
        icon={<ContentAdd />}
        labelPosition="before"
        containerElement={<Link to={`${basePath}/create`} />}
        style={styles.flat}
    />
);

CreateButton.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
    translate: PropTypes.func.isRequired
};

const enhance = compose(
    onlyUpdateForKeys(['basePath', 'label']),
    withWidth(),
    translate
);

export default enhance(CreateButton);



// WEBPACK FOOTER //
// ./src/components/CRM/CreateGiftCardButton.js